import cn from 'classnames';
import styles from './StockStatusBadge.module.scss';

interface IStockStatusBadgeProps {
  status: {
    id: number;
    name: string;
    type: string;
  };
}

const StockStatusBadge = ({ status }: IStockStatusBadgeProps) => {
  return (
    <div
      className={cn(
        styles.stockStatusBadge,
        status.type === 'active' || status.id === 1
          ? styles.stockStatusBadgeActive
          : status.type === 'archived' || status.id === 3
            ? styles.stockStatusBadgeArchive
            : styles.stockStatusBadgeFull
      )}
    >
      {status.name}
    </div>
  );
};

export default StockStatusBadge;
